"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CycloneAbilityHandler = exports.CycloneActorAbilityFactory = exports.CycloneAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Vulnerability_1 = require("../../core/effects/core/Vulnerability");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
class CycloneAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Cyclone;
        this.__typeName = "Cyclone";
    }
}
exports.CycloneAbilityArgs = CycloneAbilityArgs;
let CycloneActorAbilityFactory = class CycloneActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Cyclone", "AllEnemies", 2);
    }
};
CycloneActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Cyclone")
], CycloneActorAbilityFactory);
exports.CycloneActorAbilityFactory = CycloneActorAbilityFactory;
let CycloneAbilityHandler = class CycloneAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const targets = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        container.applyMultiAttack({
            attackerId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            sequence,
            targets: targets.map((targetId, i) => ({
                targetId,
                damages: [
                    AbilityDamage_1.AbilityDamage.Power("Physical", 50)
                ],
                effects: [
                    {
                        targetId,
                        duration: Duration_1.Duration.Turns(5),
                        effect: new Vulnerability_1.VulnerabilityEffectArgs(1)
                    }
                ]
            }))
        });
    }
};
CycloneAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Cyclone)
], CycloneAbilityHandler);
exports.CycloneAbilityHandler = CycloneAbilityHandler;
